import { clubSeasons, slotAccepts } from "./gameData";
import { FORMATIONS } from "../components/DraftBoard";

const rngFrom = (seed) => {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
};

const pick = (rng, arr) => arr[Math.floor(rng() * arr.length)];

export const toCompact = (slot) => ({
  id: slot.id, x: slot.x, y: slot.y, label: slot.label, cat: slot.cat,
  player: slot.player ? { short: slot.player.short, color: slot.player.color, rating: slot.player.rating, name: slot.player.name } : null,
});

const bestFor = (slot, squad, used) =>
  [...squad].sort((a, b) => b.rating - a.rating).find((p) => slotAccepts(slot, p) && !used.has(p.name));

// Same seed -> same daily puzzle for everyone: Pep's themed club, a fixed formation, 3 open slots.
export function buildDaily(seed) {
  const rng = rngFrom(seed);
  const theme = clubSeasons[Math.floor(rng() * clubSeasons.length)];
  const formation = pick(rng, Object.keys(FORMATIONS));
  const slots = FORMATIONS[formation].slots;

  const pepUsed = new Set();
  const pepXi = slots.map((s) => {
    const p = bestFor(s, theme.squad, pepUsed) || clubSeasons.map((c) => bestFor(s, c.squad, pepUsed)).find(Boolean);
    if (p) pepUsed.add(p.name);
    return { ...s, player: p || null };
  });

  const openIds = ["DEF", "MID", "FWD"].map((cat) => pick(rng, slots.filter((s) => s.cat === cat)).id);
  const used = new Set();
  const myXi = slots.map((s) => {
    if (openIds.includes(s.id)) return { ...s, player: null };
    for (let i = 0; i < 40; i++) {
      const club = pick(rng, clubSeasons);
      const options = club.squad.filter((p) => slotAccepts(s, p) && !used.has(p.name));
      if (options.length) {
        const p = pick(rng, options);
        used.add(p.name);
        return { ...s, player: p };
      }
    }
    return { ...s, player: null };
  });

  return { theme, formation, formationLabel: FORMATIONS[formation].label, pepXi, myXi, openCount: myXi.filter((s) => !s.player).length };
}

export const themeName = (theme) => `${theme.club} ${theme.season}`;
